module.exports = __webpack_public_path__ + "static/media/sunwise-main1.d416da0d.jpg";